import apiClient from './client';

export interface SessionPlan {
  id: string;
  title: string;
  description?: string;
  duration?: number;
  objectives?: string[];
  drills?: Array<{
    name: string;
    description?: string;
    duration?: number;
    orderIndex: number;
  }>;
  equipment?: string[];
  notes?: string;
  category?: string;
  skillLevel?: string;
  isTemplate: boolean;
  createdBy: string;
  creator?: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface GetSessionPlansParams {
  page?: number;
  limit?: number;
  category?: string;
  skillLevel?: string;
  isTemplate?: boolean;
  search?: string;
}

export const sessionPlanAPI = {
  getSessionPlans: async (params?: GetSessionPlansParams) => {
    const response = await apiClient.get('/session-plans', { params });
    return response.data;
  },

  getSessionPlanById: async (id: string) => {
    const response = await apiClient.get(`/session-plans/${id}`);
    return response.data;
  },

  createSessionPlan: async (data: Partial<SessionPlan>) => {
    const response = await apiClient.post('/session-plans', data);
    return response.data;
  },

  updateSessionPlan: async (id: string, data: Partial<SessionPlan>) => {
    const response = await apiClient.put(`/session-plans/${id}`, data);
    return response.data;
  },

  deleteSessionPlan: async (id: string) => {
    const response = await apiClient.delete(`/session-plans/${id}`);
    return response.data;
  },
};
